import { useProductImages } from '../hooks/useProductImages';

type ProductImageProps = {
	children: React.ReactNode;
};

const ProductImage = ({ children }: ProductImageProps) => {
	const { blockClass } = useProductImages();

	const renderClass = () => {
		return blockClass && `vtex-store-components-3-x-productImage--${blockClass}`;
	};

	return (
		<div className={`productImage productImage--${blockClass} vtex-store-components-3-x-productImage ${renderClass()}`}>
			{children}
		</div>
	);
};

export default ProductImage;
